// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.organiztion_section .hv-container {
  width: 100%;
  overflow-x: scroll;
  padding: 42px 0;
  overflow: auto;
}
.organiztion_section .create-tree {
  position: relative;
  max-height: 100vh;
  margin-bottom: 15px;
}

.hv-wrapper .hv-item {
  display: flex;
  flex-direction: column;
  margin: auto;
}

.hv-wrapper .hv-item .hv-item-parent {
  margin-bottom: 50px;
  position: relative;
  display: flex;
  justify-content: center;
}

.hv-wrapper .hv-item .hv-item-parent:after {
  position: absolute;
  content: "";
  width: 1px;
  height: 25px;
  bottom: 0;
  left: 50%;
  background-color: #55BDFC;
  transform: translateY(100%);
}

p {
  color: #1B2430;
  margin-bottom: 0;
}

.simple-card {
  position: relative;
  margin: 0;
  background-color: #fff;
  color: #1B2430;
  padding: 1.2rem 0.5rem;
  border-radius: 6px;
  min-width: 100px;
  text-align: center;
  border: 1px solid #55BDFC;
}
.simple-card i {
  cursor: pointer;
  font-size: 12px;
  position: absolute;
  right: 5px;
  top: 5px;
}

.tree_creation h6.title {
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
}
.tree_creation .parent-list {
  padding-left: 4px;
}
.tree_creation .parent-list li {
  position: relative;
  padding-left: 20px;
  padding-top: 6px;
  padding-bottom: 6px;
}
.tree_creation .parent-list li::before {
  content: "";
  height: 100%;
  position: absolute;
  top: 0px;
  font-size: 6px;
  left: -1px;
  width: 1px;
  border-left: 1px dotted rgba(109, 123, 130, 0.6);
}
.tree_creation .parent-list li:after {
  content: "";
  height: 1px;
  position: absolute;
  top: 12px;
  font-size: 6px;
  left: -1px;
  width: 14px;
  border-bottom: 1px dotted rgba(109, 123, 130, 0.6);
}
.tree_creation .parent-list li:last-child::before {
  content: "";
  height: 100%;
  position: absolute;
  top: 0px;
  font-size: 6px;
  left: -1px;
  width: 1px;
  border-left: 1px dotted rgba(109, 123, 130, 0.6);
}
.tree_creation .parent-list li i {
  cursor: pointer;
  font-size: 12px;
  color: #FF0C0C;
}
.tree_creation ul li div:hover,
.tree_creation ul li li div:hover,
.tree_creation ul li li li div:hover {
  color: #008ee6;
}

.hv-wrapper .hv-item .hv-item-children {
  display: flex;
  justify-content: center;
}

.hv-wrapper .hv-item .hv-item-children .hv-item-child {
  padding: 0 10px;
  position: relative;
}

.hv-wrapper .hv-item .hv-item-children .hv-item-child:before,
.hv-wrapper .hv-item .hv-item-children .hv-item-child:not(:only-child):after {
  content: "";
  position: absolute;
  background-color: #55BDFC;
  left: 0;
}

.hv-wrapper .hv-item .hv-item-children .hv-item-child:before {
  left: 50%;
  top: 0;
  transform: translateY(-100%);
  width: 1px;
  height: 25px;
}

.hv-wrapper .hv-item .hv-item-children .hv-item-child:after {
  top: -25px;
  transform: translateY(-100%);
  height: 1px;
  width: 100%;
}

.hv-wrapper .hv-item .hv-item-children .hv-item-child:first-child:after {
  left: 50%;
  width: 50%;
}

.hv-wrapper .hv-item .hv-item-children .hv-item-child:last-child:after {
  width: calc(50% + 1px);
}`, "",{"version":3,"sources":["webpack://./src/neetjee_guru/components/settings/organization/_hierarchy.scss"],"names":[],"mappings":"AAEI;EACI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AADR;AAII;EACI,kBAAA;EACA,iBAAA;EACA,mBAAA;AAFR;;AAOA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAJJ;;AAOA;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,yBAAA;EACA,2BAAA;AAJJ;;AAOA;EACI,cAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAJJ;AAOI;EACI,eAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AALR;;AAUI;EACI,eAAA;EACA,eAAA;EACA,gBAAA;AAPR;AAUI;EACI,iBAAA;AARR;AAUQ;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AARZ;AAWY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;EACA,UAAA;EACA,UAAA;EACA,gDAAA;AAThB;AAYY;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,kDAAA;AAVhB;AAaY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;EACA,UAAA;EACA,UAAA;EACA,gDAAA;AAXhB;AAcY;EACI,eAAA;EACA,eAAA;EACA,cAAA;AAZhB;AAqBQ;;;EACI,cAAA;AAjBZ;;AAuBA;EACI,aAAA;EACA,uBAAA;AApBJ;;AAuBA;EACI,eAAA;EACA,kBAAA;AApBJ;;AAuBA;;EAEI,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,OAAA;AApBJ;;AAuBA;EACI,SAAA;EACA,MAAA;EACA,4BAAA;EACA,UAAA;EACA,YAAA;AApBJ;;AAuBA;EACI,UAAA;EACA,4BAAA;EACA,WAAA;EACA,WAAA;AApBJ;;AAuBA;EACI,SAAA;EACA,UAAA;AApBJ;;AAuBA;EACI,sBAAA;AApBJ","sourcesContent":[".organiztion_section {\n\n    .hv-container {\n        width: 100%;\n        overflow-x: scroll;\n        padding: 42px 0;\n        overflow: auto;\n    }\n\n    .create-tree {\n        position: relative;\n        max-height: 100vh;\n        margin-bottom: 15px;\n    }\n}\n\n\n.hv-wrapper .hv-item {\n    display: flex;\n    flex-direction: column;\n    margin: auto;\n}\n\n.hv-wrapper .hv-item .hv-item-parent {\n    margin-bottom: 50px;\n    position: relative;\n    display: flex;\n    justify-content: center;\n}\n\n.hv-wrapper .hv-item .hv-item-parent:after {\n    position: absolute;\n    content: '';\n    width: 1px;\n    height: 25px;\n    bottom: 0;\n    left: 50%;\n    background-color: #55BDFC;\n    transform: translateY(100%);\n}\n\np {\n    color: #1B2430;\n    margin-bottom: 0;\n}\n\n.simple-card {\n    position: relative;\n    margin: 0;\n    background-color: #fff;\n    color: #1B2430;\n    padding: 1.2rem 0.5rem;\n    border-radius: 6px;\n    min-width: 100px;\n    text-align: center;\n    border: 1px solid #55BDFC;\n\n    // box-shadow: 0 3px 6px rgba(204, 131, 103, 0.22);\n    i {\n        cursor: pointer;\n        font-size: 12px;\n        position: absolute;\n        right: 5px;\n        top: 5px;\n    }\n}\n\n.tree_creation {\n    h6.title {\n        cursor: pointer;\n        font-size: 14px;\n        font-weight: 400;\n    }\n\n    .parent-list {\n        padding-left: 4px;\n\n        li {\n            position: relative;\n            padding-left: 20px;\n            padding-top: 6px;\n            padding-bottom: 6px;\n            // border-left: 1px dotted rgba(109, 123, 130, 0.6);\n\n            &::before {\n                content: \"\";\n                height: 100%;\n                position: absolute;\n                top: 0px;\n                font-size: 6px;\n                left: -1px;\n                width: 1px;\n                border-left: 1px dotted rgba(109, 123, 130, 0.6);\n            }\n\n            &:after {\n                content: \"\";\n                height: 1px;\n                position: absolute;\n                top: 12px;\n                font-size: 6px;\n                left: -1px;\n                width: 14px;\n                border-bottom: 1px dotted rgba(109, 123, 130, 0.6);\n            }\n\n            &:last-child::before {\n                content: \"\";\n                height: 100%;\n                position: absolute;\n                top: 0px;\n                font-size: 6px;\n                left: -1px;\n                width: 1px;\n                border-left: 1px dotted rgba(109, 123, 130, 0.6);\n            }\n\n            i {\n                cursor: pointer;\n                font-size: 12px;\n                color: #FF0C0C;\n            }\n        }\n\n    }\n\n    ul li div,\n    ul li li div,\n    ul li li li div {\n        &:hover {\n            color: #008ee6;\n        }\n    }\n\n}\n\n.hv-wrapper .hv-item .hv-item-children {\n    display: flex;\n    justify-content: center;\n}\n\n.hv-wrapper .hv-item .hv-item-children .hv-item-child {\n    padding: 0 10px;\n    position: relative;\n}\n\n.hv-wrapper .hv-item .hv-item-children .hv-item-child:before,\n.hv-wrapper .hv-item .hv-item-children .hv-item-child:not(:only-child):after {\n    content: '';\n    position: absolute;\n    background-color: #55BDFC;\n    left: 0;\n}\n\n.hv-wrapper .hv-item .hv-item-children .hv-item-child:before {\n    left: 50%;\n    top: 0;\n    transform: translateY(-100%);\n    width: 1px;\n    height: 25px;\n}\n\n.hv-wrapper .hv-item .hv-item-children .hv-item-child:after {\n    top: -25px;\n    transform: translateY(-100%);\n    height: 1px;\n    width: 100%;\n}\n\n.hv-wrapper .hv-item .hv-item-children .hv-item-child:first-child:after {\n    left: 50%;\n    width: 50%;\n}\n\n.hv-wrapper .hv-item .hv-item-children .hv-item-child:last-child:after {\n    width: calc(50% + 1px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
